import React from 'react';

import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { ProjectListLayout } from 'common/components/layouts';
import { useSelector } from 'react-redux';

import ProjectList from './ProjectList';

import './ProjectsPage.scss';
import { GlobalToggleNotAvailable } from '../../common/components/GlobalToggleNotAvailable';

const ProjectsPage = () => {
  const isFakeClientUser = useSelector(getFakeClientUser);

  if (isFakeClientUser) {
    return <GlobalToggleNotAvailable />;
  }

  return (
    <ProjectListLayout>
      <ProjectList />
    </ProjectListLayout>
  );
};

ProjectsPage.propTypes = {};

export default ProjectsPage;
